module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chap_title",
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _vm._v("c. 18,000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")])]), _vm._v(" "), _c('h2', {
    staticClass: "section1"
  }, [_vm._v("Ishango Bone "), _c('span', {
    staticClass: "gray1"
  }, [_vm._v("• "), _c('em', [_vm._v("Clifford A. Pickover")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("In 1960, Belgian geologist and explorer Jean de Heinzelin de Braucourt (1920–1998) discovered a baboon bone with markings in what is today the Democratic Republic of the Congo. The Ishango bone, with its sequence of notches, was first thought to be a simple tally stick used by a Stone Age African. However, according to some scientists, the marks suggest a mathematical prowess that goes beyond counting of objects.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The bone was found in Ishango, near the headwaters of the Nile River, the home of a large population of upper Paleolithic people prior to a volcanic eruption that buried the area. One column of marks on the bone begins with three notches that double to six notches. Four notches double to eight. Ten notches halve to five. This may suggest a simple understanding of doubling or halving. Even more striking is the fact that numbers in other columns are all odd (9, 11, 13, 17, 19, and 21). One column contains the prime numbers between 10 and 20, and the numbers in each column sum to 60 or 48, both multiples of 12.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A number of tally sticks have been discovered that predate the Ishango bone. For example, the Swaziland Lebombo bone is a 37,000-year-old baboon fibula with 29 notches. A 32,000-year-old wolf tibia with 57 notches, grouped in fives, was found in Czechoslovakia. Although quite speculative, some have hypothesized that the markings on the Ishango bone form a kind of lunar calendar for a Stone Age woman who kept track of her menstrual cycles, giving rise to the slogan “menstruation created mathematics.” Even if the Ishango was a simple bookkeeping device, these tallies seem to set us apart from the animals and represent the first steps to symbolic mathematics. The full mystery of the Ishango bone can’t be solved until other similar bones are discovered.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454933007_epub_c08_r1#c08"
    }
  }, [_vm._v("Dice (c. 3000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")]), _vm._v(")")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454933007_epub_c24_r1#c24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sieve of Eratosthenes (c. 240 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")]), _vm._v(")")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454933007_epub_c26_r1#c26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Antikythera Mechanism (c. 125 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")]), _vm._v(")")]), _vm._v(" "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454933007_epub_c44_r1#c44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slide Rule (1621)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("The Ishango baboon bone, with its sequence of notches, was first thought to be a simple tally stick used by a Stone Age African. However, some scientists believe that the marks suggest a mathematical prowess that goes beyond counting of objects.")])]), _vm._v(" "), _c('div', {
    staticClass: "title1"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "id": "page13_1",
      "src": "Images/13-1.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-883a115e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454933007_epub_c01_r1.vue
// module id = 72
// module chunks = 0